import {
  Select,
  SelectValue,
  SelectTrigger,
  SelectContent,
  SelectGroup,
  SelectItem,
} from '@dc-shared-web/components/shadcn'

const SelectRow = ({
  label,
  value,
  options,
  onChange,
  disabled,
}: {
  label: string
  value: string
  options: { value: string; text: string }[]
  disabled?: boolean
  onChange: (value: string) => void
}) => {
  return (
    <div className='tw-flex tw-flex-col tw-gap-1'>
      <p className='tw-text-sm'>{label}</p>
      <Select value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>
        <SelectContent className='tw-z-[51]'>
          <SelectGroup>
            {options.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.text}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  )
}

export default SelectRow
